/* Illumivein theme — storefront interactions (vanilla, no dependencies) */
(function () {
  "use strict";

  /* ---- Mobile menu -------------------------------------------------------- */
  function initMobileMenu() {
    var burger = document.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!burger || !menu) return;
    burger.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) menu.classList.remove("is-open");
    });
  }

  /* ---- FAQ accordion (one open at a time) --------------------------------- */
  function initFaq() {
    document.querySelectorAll("[data-faq]").forEach(function (faq) {
      var items = faq.querySelectorAll("[data-faq-item]");
      items.forEach(function (item) {
        var head = item.querySelector("[data-faq-head]");
        if (!head) return;
        head.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          items.forEach(function (i) {
            i.classList.remove("is-open");
            var s = i.querySelector("[data-faq-sign]");
            if (s) s.textContent = "+";
          });
          if (!isOpen) {
            item.classList.add("is-open");
            var sign = item.querySelector("[data-faq-sign]");
            if (sign) sign.textContent = "–";
          }
        });
      });
    });
  }

  /* ---- Product gallery (thumbnail -> main swap) --------------------------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var src = thumb.getAttribute("data-src");
          var alt = thumb.getAttribute("data-alt") || "";
          if (main && src) {
            main.setAttribute("src", src);
            main.setAttribute("alt", alt);
          }
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---- Quantity steppers + live ATC total -------------------------------- */
  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("[data-qty-input]");
      var dec = wrap.querySelector("[data-qty-dec]");
      var inc = wrap.querySelector("[data-qty-inc]");
      var min = parseInt(wrap.getAttribute("data-qty-min") || "1", 10);
      var max = parseInt(wrap.getAttribute("data-qty-max") || "99", 10);
      if (!input) return;
      function clamp(v) { return Math.max(min, Math.min(max, v)); }
      var unit = parseInt(wrap.getAttribute("data-unit-price") || "0", 10);
      function sync() {
        var v = clamp(parseInt(input.value || min, 10) || min);
        input.value = v;
        var form = wrap.closest("form");
        var totalEl = form && form.querySelector("[data-atc-total]");
        if (totalEl && unit) totalEl.textContent = money(unit * v);
      }
      function step(delta) {
        input.value = clamp((parseInt(input.value, 10) || min) + delta);
        sync();
        // Fire a real change event so cart inputs (onchange="this.form.submit()")
        // actually persist the new quantity — a programmatic value set alone does not.
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      if (dec) dec.addEventListener("click", function () { step(-1); });
      if (inc) inc.addEventListener("click", function () { step(1); });
      input.addEventListener("change", sync);
      sync();
    });
  }

  /* ---- Cart page: covers upsell toggle + countdown ----------------------- */
  function initCoversUpsell() {
    var box = document.querySelector("[data-covers-upsell]");
    if (!box) return;

    var countdown = box.querySelector("[data-countdown]");
    if (countdown) {
      var secs = 9 * 60;
      var tick = function () {
        var m = Math.floor(secs / 60), s = secs % 60;
        countdown.textContent = m + ":" + String(s).padStart(2, "0");
        if (secs > 0) secs -= 1;
      };
      tick();
      setInterval(tick, 1000);
    }

    var toggle = box.querySelector("[data-covers-toggle]");
    if (toggle) {
      toggle.addEventListener("click", function () {
        var variantId = box.getAttribute("data-covers-variant");
        if (!variantId) return;
        toggle.setAttribute("aria-disabled", "true");
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { track("Covers upsell added"); window.location.reload(); })
          .catch(function () { toggle.removeAttribute("aria-disabled"); });
      });
    }
  }

  /* ---- Cart page: last-chance covers popup before checkout ---------------- */
  function initCheckoutUpsell() {
    var modal = document.querySelector("[data-upsell-modal]");
    var form = document.querySelector("[data-checkout-form]");
    if (!form) return;

    function goToCheckout() { window.location.href = "/checkout"; }

    // No modal (covers already in cart, or unavailable) → let checkout proceed normally.
    if (!modal) return;

    var card = modal.querySelector(".upsell-modal__card");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      modal.hidden = false;
    });

    var dismiss = modal.querySelector("[data-upsell-dismiss]");
    if (dismiss) dismiss.addEventListener("click", function () { modal.hidden = true; });

    var no = modal.querySelector("[data-upsell-no]");
    if (no) no.addEventListener("click", goToCheckout);

    var yes = modal.querySelector("[data-upsell-yes]");
    if (yes) {
      yes.addEventListener("click", function () {
        var variantId = modal.getAttribute("data-covers-variant");
        if (!variantId) { goToCheckout(); return; }
        if (card) card.classList.add("is-loading");
        yes.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function () { track("Covers upsell added"); goToCheckout(); })
          .catch(function () { goToCheckout(); });
      });
    }
  }

  /* ---- Creator form → webhook (Make/Zapier → Airtable) -------------------- */
  function initCreatorWebhook() {
    var host = document.querySelector("[data-webhook]");
    if (!host) return;
    var url = host.getAttribute("data-webhook");
    if (!url) return;
    var form = host.querySelector("form");
    if (!form) return;
    form.addEventListener("submit", function () {
      try {
        // Send as application/x-www-form-urlencoded (URLSearchParams). This is a
        // CORS-safelisted content type, so the browser does NOT fire a preflight
        // OPTIONS — a JSON blob does, and Make's webhook drops preflights, silently
        // killing the POST. Make parses each urlencoded field by name.
        var params = new URLSearchParams();
        params.append("Source", "Application page");
        new FormData(form).forEach(function (v, k) {
          var m = k.match(/^contact\[(.+)\]$/);
          params.append(m ? m[1] : k, v);
        });
        // sendBeacon survives the page navigation the form triggers.
        navigator.sendBeacon(url, params);
      } catch (e) {}
    });
  }

  /* ---- Creator shipping page: prefill rid + email from the emailed link ---- */
  function initCreatorShippingPrefill() {
    var form = document.getElementById("creator-shipping-form");
    if (!form) return;
    var q = new URLSearchParams(window.location.search);
    var rid = q.get("rid");
    var email = q.get("e") || q.get("email");
    var ridEl = form.querySelector('[data-fill="rid"]');
    var emailEl = form.querySelector('[data-fill="email"]');
    if (ridEl && rid) ridEl.value = rid;
    if (emailEl && email && !emailEl.value) emailEl.value = email;
  }

  /* ---- Blog article: sticky order bar ------------------------------------- */
  function initArticleSticky() {
    var bar = document.querySelector("[data-article-sticky]");
    if (!bar) return;
    if (sessionStorage.getItem("ilv_sticky_dismissed") === "1") return;

    bar.hidden = false;
    var shown = false;
    function onScroll() {
      if (shown) return;
      if (window.scrollY > 500) {
        bar.classList.add("is-visible");
        shown = true;
        track("Article sticky shown");
        window.removeEventListener("scroll", onScroll);
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    var close = bar.querySelector("[data-article-sticky-close]");
    if (close) {
      close.addEventListener("click", function () {
        bar.classList.remove("is-visible");
        try { sessionStorage.setItem("ilv_sticky_dismissed", "1"); } catch (e) {}
      });
    }
  }

  /* ---- Product page: sticky mobile add-to-cart --------------------------- */
  function initPdpSticky() {
    var bar = document.querySelector("[data-pdp-sticky]");
    var atc = document.querySelector(".pdp__atc");
    if (!bar || !atc || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      // Show the sticky bar only once the main Add-to-Cart has scrolled out of view.
      bar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(atc);
  }

  /* ---- Plausible custom events (safe no-op if Plausible isn't loaded) ------ */
  function track(name) {
    if (typeof window.plausible === "function") { window.plausible(name); }
  }
  function initTracking() {
    // Add to cart — any form that posts to /cart/add (order buttons, PDP, buy box)
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function () { track("Add to cart"); });
    });
    // Begin checkout — the cart's checkout button
    var checkoutForm = document.querySelector("[data-checkout-form]");
    if (checkoutForm) checkoutForm.addEventListener("submit", function () { track("Begin checkout"); });
    // Newsletter (blog) and contact form submits
    var news = document.querySelector(".blog__newsletter-form");
    if (news) news.addEventListener("submit", function () { track("Newsletter signup"); });
    var contact = document.getElementById("contact-form");
    if (contact) contact.addEventListener("submit", function () { track("Contact form submit"); });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initMobileMenu();
    initFaq();
    initGallery();
    initQty();
    initCoversUpsell();
    initCheckoutUpsell();
    initArticleSticky();
    initCreatorWebhook();
    initCreatorShippingPrefill();
    initPdpSticky();
    initTracking();
  });
})();
